
import React, { useState, useEffect, use } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import apiCalls from "../../../../config/apiCalls";
import NewUserModal from "../../CommonModals/NewUserModal";
import FormModal from "../../../Form/FormModal";
import filePath from "../../../../config/configSampleFiles";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
import config from "../../../../config/config";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import store from "../../../App/store";
import fetchMethodRequest from "../../../../config/service";

// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @StorageUnitItems
 * @Storage Unit Items
 * @storageUnitItems
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Storage Unit","derivedValue":"storageUnit=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"storageUnit","showOrHideFields":[],"fieldName":"storageUnit","mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"noOfItems","type":"text","placeholder":"No Of Items","label":"No Of Items","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"No Of Items","derivedValue":"noOfItems=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"noOfItems","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"textAlign":"Center","show":true,"field":"noOfItems","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"storageUnit","type":"text","placeholder":"Storage Unit","label":"Storage Unit","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"storageUnit=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"storageUnit","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"fieldName":"storageUnit","mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"noOfItems","type":"text","placeholder":"No Of Items","label":"No Of Items","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"noOfItems=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"noOfItems","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"validationRequired":true,"regexPattern":"^[0-9]$","regexData":{"showMinField":false,"minLengthRequired":false,"minLengthText":null,"showMaxField":false,"maxLengthRequired":false,"maxLengthText":null,"alphabetsRequired":false,"showAlphaField":false,"numbersRequired":true,"showNumField":true,"specialCharRequired":false,"showSCharField":false,"specialCharText":null},"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const ActiveCompanies = (props) => {
  const [rolePermission, setRolePermission] = useState();
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  let [type, setType] = useState("Active Companies");
  const [routeTo, setRouteTo] = useState('');

  const [paramsObj, setParamsObj] = useState();
  const [path, setPath] = useState(undefined);


  const params = useParams();
  useEffect(() => {
    let screenPermissions =
      RolePermissions.screenPermissions("Storage Unit Items");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
    if (params) {
    } else {
      setParamsObj({})
    }
    headerNames();
  }, [window.location.pathname]);

  const getHeader = (type) => {
    return (
      // type === 'Categoriess in companies' ? 'Categories in companies' :
      //   type === 'Activitiess in companies' ? 'Activities in companies' :
      //     type === 'Distributorss in companies' ? 'Distributors in companies' :
      //       type === 'RequiredInventoriess in companies' ? 'RequiredInventories in companies' :
      //         type === 'Orderss in companies' ? 'Orders in companies' :
      //           type === 'BatteryCheckss in companies' ? 'BatteryChecks in companies' :
      //             type === 'StorageUnitCheckss in companies' ? 'StorageUnitChecks in companies' :
      //               type === 'RecallItemss in companies' ? 'RecallItems in companies' :
      //                 type === 'ExpirationItemss in companies' ? 'ExpirationItems in companies' :
      //                   type === 'StorageUnitss in companies' ? 'StorageUnits in companies' :
      //                     type === 'Facilitiess in companies' ? 'Facilities in companies' :
      //                       type === 'StorageUnitItemss in companies' ? 'Storage Unit Items in Companies' :
      //                         type === 'InventoryCheckss in companies' ? 'Inventory CheckList in companies' :
      //                           type === 'Expirationdates in companies' ? 'Expiration Dates in companies' :
      //                             type === 'Batterychecks in companies' ? 'Battery Checks in companies' :
      //                               type === 'FacilityStaffss in companies' ? 'FacilityStaffs in companies' :
      //                                 type === 'Productdirectory in companies' ? 'Product Directory in companies' :
      //                                   type === 'Expiration Dates' ? 'Expired Items' :
      //                                     type === 'Facilitystaffroles in companies' ? 'Facility Staff Roles in companies' :
      type
    );
  }

  const headerNames = () => {
    if (type !== window.location.pathname.slice(1, window.location.pathname)) {
      let currentPath = window.location.pathname.slice(1, -1);
      setRouteTo(currentPath)
      if (window.location.pathname) {
        type = `${window.location.pathname.slice(1, 2).toUpperCase()
          + window.location.pathname.slice(2)} in companies`;
        setType(getHeader(type))

      }
      return null;
    } else {
      return null;
    }
  }

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };




  const getTableFields = () => {
    let roleTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "Super Admin",
        value: "Super Admin",
      },
      {
        label: "User",
        value: "User",
      },
    ];
    let StatusTypes = [
      {
        label: "All",
        value: null,
      },
      {
        label: "Active",
        value: "Active",
      },
      {
        label: "Inactive",
        value: "Inactive",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
    let data = [

      {
        textAlign: "center",
        width: 47,
        field: "Sno",
        label: "SNo",
        header: "S.No",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },
      {
        name: "companyName",
        type: "text",
        placeholder: "Company",
        label: "Company",
        width: "300px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Company",
        derivedValue: "companyName=facilityName=undefined",
        capitalizeTableText: true,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "companyName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "companyName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,

      },

      {
        name: "email",
        type: "text",
        placeholder: "Company",
        label: "Company",
        width: "300px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Company Email",
        derivedValue: "email=facilityemail=undefined",
        capitalizeTableText: true,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "email",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "email",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,

      },


    ];
    return data;
  };

  const getFormFields = () => {
  };


  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();


  };

  return (
    <span>
      {
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          addRequired={false}
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          refresh={true}
          getPagination={true}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["storageUnitItems"]}
          globalSearch={false}
          type='Companies'
          name="Active Companies"
          routeTo={'companies'}
          displayViewOfForm="modal"
          sideFormLeftOrRight=""
          selectionMode={true}
          //   modalHeaderName="Active Companys"
          apiResponseKey={"companies"}
          apiUrl={apiCalls["companies"]}
          selectedId={params.id}
          redirectTo={routeTo ? routeTo : null}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          modalHeaderName="Active Companys"
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}

          recordId={item._id}
          entityType="activeCompanys"
          apiUrl={apiCalls["storageUnitItems"]}
        />
      ) : null}
    </span>
  );
};

export default ActiveCompanies;

